import styled from 'styled-components'

export const PaginationWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: var(--bq-spacing-xs) 0;
  bottom: 0;
`
